import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f2f0640e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navigation navigation--corners usesMixBlendMode" }
const _hoisted_2 = {
  href: "/",
  class: "navigation__logo"
}
const _hoisted_3 = { class: "navigation navigation--top usesMixBlendMode" }
const _hoisted_4 = { class: "navigation__main_menu" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "navigation__main_menu_label" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "navigation__side_menu_item__label_container navigation__side_menu_item__label_container--tickets" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "navigation__side_menu_item__label" }, "kaartjes")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "navigation__side_menu_item__label_container navigation__side_menu_item__label_container--search" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "navigation__side_menu_item__label" }, "zoeken")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "navigation__side_menu_item__label_container navigation__side_menu_item__label_container--mail" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "navigation__side_menu_item__label" }, "contact")
], -1))
const _hoisted_10 = { class: "fullscreen_navigation" }
const _hoisted_11 = { class: "fullscreen_navigation__container" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fullscreen_navigation__light" }, null, -1))
const _hoisted_13 = { class: "fullscreen_navigation__content" }
const _hoisted_14 = { class: "fullscreen_navigation__illustration" }
const _hoisted_15 = { class: "fullscreen_navigation__main_menu" }
const _hoisted_16 = ["href"]
const _hoisted_17 = { class: "fullscreen_navigation__main_menu_label" }
const _hoisted_18 = { class: "fullscreen_navigation__secondary_menu" }
const _hoisted_19 = ["href"]
const _hoisted_20 = { class: "fullscreen_navigation__secondary_menu_label" }
const _hoisted_21 = { class: "fullscreen_navigation__tertiary_menu" }
const _hoisted_22 = { class: "fullscreen_navigation__tertiary_item_container" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fullscreen_navigation__tertiary_item__label" }, "tickets", -1))
const _hoisted_24 = { class: "fullscreen_navigation__tertiary_item_container" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fullscreen_navigation__tertiary_item__label" }, "zoeken", -1))
const _hoisted_26 = { class: "fullscreen_navigation__tertiary_item_container" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fullscreen_navigation__tertiary_item__label" }, "contact", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Textures = _resolveComponent("Textures")!
  const _component_Mijnwerker = _resolveComponent("Mijnwerker")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("a", _hoisted_2, [
        _createVNode(_component_Icon, { type: "logo" })
      ]),
      _createElementVNode("div", {
        class: "navigation__menu_toggle",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleFullscreenMenu(true)))
      }, [
        _createVNode(_component_Icon, {
          type: "menu",
          class: "navigation__menu_toggle__item navigation__menu_toggle__item--menu"
        }),
        _createVNode(_component_Icon, {
          type: "close",
          class: "navigation__menu_toggle__item navigation__menu_toggle__item--close"
        })
      ])
    ]),
    _createElementVNode("nav", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.primaryLinks, (link, index) => {
          return (_openBlock(), _createElementBlock("a", {
            href: link.href,
            class: "navigation__main_menu_item",
            key: `main-menu-${index}`
          }, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(link.title), 1)
          ], 8, _hoisted_5))
        }), 128))
      ])
    ]),
    _createElementVNode("div", {
      class: "navigation__side_menu__close_overlay",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleSidebar && _ctx.toggleSidebar(...args))),
      "data-sidebar": "none"
    }),
    _createElementVNode("a", {
      href: "#",
      class: "navigation__side_menu_item usesMixBlendMode hideOnFooter",
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleSidebar && _ctx.toggleSidebar(...args))),
      "data-sidebar": "tickets"
    }, [
      _createVNode(_component_Icon, {
        type: "tickets",
        class: "navigation__side_menu_item__icon"
      }),
      _hoisted_7
    ]),
    _createElementVNode("a", {
      href: "#",
      class: "navigation__side_menu_item usesMixBlendMode hideOnFooter",
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleSidebar && _ctx.toggleSidebar(...args))),
      "data-sidebar": "search"
    }, [
      _createVNode(_component_Icon, {
        type: "search",
        class: "navigation__side_menu_item__icon"
      }),
      _hoisted_8
    ]),
    _createElementVNode("a", {
      href: "#",
      class: "navigation__side_menu_item usesMixBlendMode hideOnFooter",
      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggleSidebar && _ctx.toggleSidebar(...args))),
      "data-sidebar": "contact"
    }, [
      _createVNode(_component_Icon, {
        type: "mail",
        class: "navigation__side_menu_item__icon"
      }),
      _hoisted_9
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createVNode(_component_Textures, {
          class: "fullscreen_navigation__texture",
          type: "fine-01"
        }),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_Mijnwerker)
          ]),
          _createElementVNode("nav", _hoisted_15, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.primaryLinks, (link, index) => {
              return (_openBlock(), _createElementBlock("a", {
                href: link.href,
                class: "fullscreen_navigation__main_menu_item",
                key: `fullscreen-main-menu-${index}`,
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.toggleFullscreenMenu && _ctx.toggleFullscreenMenu(...args)))
              }, [
                _createElementVNode("span", _hoisted_17, _toDisplayString(link.title), 1)
              ], 8, _hoisted_16))
            }), 128))
          ]),
          _createElementVNode("nav", _hoisted_18, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.secondaryLinks, (link, index) => {
              return (_openBlock(), _createElementBlock("a", {
                href: link.href,
                class: "fullscreen_navigation__secondary_menu_item",
                key: `fullscreen-secondary-menu-${index}`,
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.toggleFullscreenMenu && _ctx.toggleFullscreenMenu(...args)))
              }, [
                _createElementVNode("span", _hoisted_20, _toDisplayString(link.title), 1)
              ], 8, _hoisted_19))
            }), 128))
          ]),
          _createElementVNode("nav", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("a", {
                href: "#",
                class: "fullscreen_navigation__tertiary_item",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.toggleSidebar && _ctx.toggleSidebar(...args))),
                "data-sidebar": "tickets"
              }, [
                _createVNode(_component_Icon, {
                  type: "tickets",
                  class: "fullscreen_navigation__tertiary_item__icon"
                }),
                _hoisted_23
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("a", {
                href: "#",
                class: "fullscreen_navigation__tertiary_item",
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.toggleSidebar && _ctx.toggleSidebar(...args))),
                "data-sidebar": "search"
              }, [
                _createVNode(_component_Icon, {
                  type: "search",
                  class: "fullscreen_navigation__tertiary_item__icon"
                }),
                _hoisted_25
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("a", {
                href: "#",
                class: "fullscreen_navigation__tertiary_item",
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.toggleSidebar && _ctx.toggleSidebar(...args))),
                "data-sidebar": "contact"
              }, [
                _createVNode(_component_Icon, {
                  type: "mail",
                  class: "fullscreen_navigation__tertiary_item__icon"
                }),
                _hoisted_27
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}